import axios from 'axios'
import RemoveRepeatAjax from './rmRepeatAjax'
// import { getCookie } from '../../utils/system'
const axiosInstance = axios.create()

axiosInstance.defaults.timeout = 6000 // 目前nginx timeout时间是5000
axiosInstance.defaults.withCredentials = true

const rmRepeatAjax = new RemoveRepeatAjax()

// 添加请求拦截器
// 在发送请求之前做些什么
axiosInstance.interceptors.request.use(
  function (config) {
    rmRepeatAjax.removePendingAjax(config.url)

    config.cancelToken = new axios.CancelToken(c => {
      rmRepeatAjax.pushPendingAjax({ url: config.url, c })
    })

    // 花火前端使用互选后端相关接口,后端需要根据header鉴权
    // 接口文档: https://info.bilibili.co/pages/viewpage.action?pageId=509329491&preview=/509329491/509331173/image2022-7-13_17-47-26.png#id-%E8%8A%B1%E7%81%AB%E4%BB%BB%E5%8A%A1%E7%BA%BF%E7%B4%A2%E9%80%9A%E6%95%B4%E5%90%88%E6%8E%A5%E5%8F%A3-%E4%BF%AE%E6%94%B9%E4%BB%BB%E5%8A%A1
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
// 对响应数据做点什么
axiosInstance.interceptors.response.use(
  function (response) {
    rmRepeatAjax.removePendingAjax(response.config.url, 'resp')

    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default axiosInstance
